module.exports = __webpack_public_path__ + "img/featured-tablet-cta-1.02463a47.jpg";